import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, setIsSubmit, setPersonalInfo, reportDWH, setIsEmailAvailable } from '../saleJetBlockSlice';
import PersonalInfo from '../Partials/PersonalInfo/PersonalInfo';
import { emailIsExist } from '../saleBlockAsyncThunk';
import {dwhThirdPartyConsentCheckboxDisplay} from "../../ChangePricePlanBlock/reports/dwhReports";
import { gtag4 } from '../../../../utilities/analytics/tracking';

const PersonalInfoPage = (props) => {

  useEffect(() => {
    props.reportDWH({ actionType: 'Customer Info', status: 'Ongoing', messageText: 'Customer Info Displayed' });

    gtag4({
      event: props.saleType == "cellular" ? 'cellular_Step10_PersonalInfoPage' : `${props.saleType}_Step7_PersonalInfoPage`,
      step: props.saleType == "cellular" ? '10' : '7',
      action: 'PersonalInfoPage',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`,
    });
    if (props.showCollaborationApproval){
        dwhThirdPartyConsentCheckboxDisplay(props.userDetails.firstName + " " + props.userDetails.lastName, props.userDetails.phone, props.userDetails.IDNumber, "מכר " + props.saleType)
    }
  }, []);

  //page params
  let title = props.saleType == "cellular" ? 'נעשה היכרות קצרה ונמשיך' :  'עוד כמה פרטים ואנחנו בדרך אליך';
  let isDisplayFooter = true;
  let btnText = props.saleType == "cellular" ? 'אפשר להמשיך' : 'מעבר לתשלום מאובטח';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  // const isDisplayCheckboxTerms = props.isSelectedSeparateInvoice == false;
  const isDisplayCheckboxIsReceivingBill = false;
  const isDisplayCheckboxReceivingAd = props.showCollaborationApproval;
  const isDisplayTvRemark = (props.saleType != "internet" && props.saleType != "cellular" );
  const isIncludeTv = (props.saleType != "internet" && props.saleType != "cellular");
  const isDisplayEsimRemark = (props.saleType == "cellular" && props.isSelectedEsim );

  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'>{title}</h1>
      <h2 className='sale-title-small'></h2>
    </div>
  );

  let currentPageView = (
    <div>
      <PersonalInfo
        onSubmit={props.isSubmit}
        onValid={handlePageValidate}
        isEmailAvailable={props.isEmailAvailable}
        firstName={props.firstName}
        lastName={props.lastName}
        flowType={props.flowType}
        isReceivingBill={props.isReceivingBill}
        isReceivingAd={props.isReceivingAd}
        // isDisplayCheckboxTerms={isDisplayCheckboxTerms}
        isDisplayCheckboxIsReceivingBill={isDisplayCheckboxIsReceivingBill}
        isDisplayCheckboxReceivingAd={isDisplayCheckboxReceivingAd}
        programDetailsLink={props.programDetailsLink}
        connectionAgreementLink={props.connectionAgreementLink}
        generalTermsAgreementLink={props.generalTermsAgreementLink}
        advertisingInfoLink={props.advertisingInfoLink}
        isDisplayTvRemark={isDisplayTvRemark}
        isDisplayEsimRemark={isDisplayEsimRemark} />
    </div>
  );

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content personalInfo'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );

  function handlePageContinue() {
    props.setIsSubmit(true);
  }


  async function handlePageValidate(data) {
    props.setIsSubmit(false);
    props.setIsEmailAvailable(true);
    gtag4({
      event: props.saleType == "cellular" ? 'cellular_Step10_PersonalInfoContinueButton' : `${props.saleType}_Step7_PersonalInfoContinueButton`,
      step: props.saleType == "cellular" ? '10' : '7',
      button: btnText,
      action: 'PersonalInfoContinueButton',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`,
    });
    if (data.isValid) {
      if (isIncludeTv) {
        const isAvailableEmail = await props.emailIsExist({ eMailAddress: data.personalDetails.email, captchaToken: "" });
        if (isAvailableEmail.payload) {
          handlePageContinueAfterValid(data);
        }
      }
      else {
        handlePageContinueAfterValid(data);
      }
    }
  }

  function handlePageContinueAfterValid(data) {
    let isReceivingBill = data.personalDetails.isReceivingBill;
    if (props.flowType == 'newCustomer' && (props.saleType == 'tv' || props.saleType == 'app' || props.saleType == 'triple')) {
      isReceivingBill = true;
    }

    const personalInfo = {
      firstName: data.personalDetails.firstName,
      lastName: data.personalDetails.lastName,
      email: data.personalDetails.email,
      isReceivingAd: data.personalDetails.isReceivingAd,
      isReceivingBill: isReceivingBill
    };
    props.setPersonalInfo(personalInfo);
    props.reportDWH({ actionType: 'Personal Info', status: 'Ongoing', messageText: 'Personal Info Button Clicked' });

    if(props.saleType == 'cellular'){
      props.goToPage('addressPage');
    }
    else {
      props.goToPage('summaryPage');
    }

  }

  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    flowType: state.saleJetBlock.flowType,
    isCustomerExists: state.saleJetBlock.personalInfo.isCustomerExists,
    offerName: state.saleJetBlock.offerName,
    isSubmit: state.saleJetBlock.isSubmit,
    showCollaborationApproval: state.saleJetBlock.checkUserResponse.showCollaborationApproval,
    firstName: state.saleJetBlock.personalInfo.firstName,
    lastName: state.saleJetBlock.personalInfo.lastName,
    isEmailAvailable: state.saleJetBlock.isEmailAvailable,
    userDetails: state.authentication.loginData.userDetails,
    programDetailsLink: state.saleJetBlock.selectedPackage.programDetailsLink,
    connectionAgreementLink: state.saleJetBlock.selectedPackage.connectionAgreementLink,
    generalTermsAgreementLink: state.saleJetBlock.saleBlockData.generalTermsAgreementLink,
    advertisingInfoLink: state.saleJetBlock.saleBlockData.advertisingInfoLink,
    isSelectedEsim : state.saleJetBlock.cellular.isSelectedEsim,

    isReceivingBill: state.saleJetBlock.personalInfo.isReceivingBill,
    isReceivingAd: state.saleJetBlock.personalInfo.isReceivingAd,
    isSelectedSeparateInvoice: state.saleJetBlock.userAddressPage.isSelectedSeparateInvoice,
    totalPrice: state.saleJetBlock.totalPrice
    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  setIsSubmit,
  setPersonalInfo,
  reportDWH,
  emailIsExist,
  setIsEmailAvailable
};

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfoPage);
